import { apiClient } from './client'
import type { AuthResponse } from './types'

export const authApi = {
  async register(email: string, username: string, password: string): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/v1/auth/register', { email, username, password })
    return data
  },

  async login(email: string, password: string): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/v1/auth/login', { email, password })
    return data
  },

  async refresh(): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/v1/auth/refresh')
    return data
  },

  async logout(): Promise<void> {
    await apiClient.post('/v1/auth/logout')
  },
}
